import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { urls } from 'helpers/url';
import { Link } from 'react-router';
import { FontIcon } from 'react-toolbox';
import moment from 'moment';

const CalendarNavigationButton = ({ startDate, increment, className, icon, filters, navigate }) => {
  const nextDate = moment(startDate).add(increment, 'days');
  const options = {};
  if (Object.keys(filters).length) options.query = filters;

  const content = <FontIcon value={icon} />;

  return navigate
    ? <a className={className} onClick={navigate} tabIndex="0">{content}</a>
    : <Link className={className} to={urls.schedule(nextDate, options)}>{content}</Link>;
};

CalendarNavigationButton.propTypes = {
  startDate: PropTypes.string.isRequired,
  increment: PropTypes.number.isRequired,
  className: PropTypes.string,
  icon: PropTypes.string,
  filters: PropTypes.object,
  navigate: PropTypes.func,
};

export default connect(
  state => ({ startDate: state.schedule.startDate, filters: state.schedule.filters }),
)(CalendarNavigationButton);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/schedule/components/calendarNavigationButton.jsx